export interface IMetaConfig {
  name: string
  hash: string
  version: string
  currentTime: string
}

export interface IServerConfig {
  protocol: string
  host: string
  post: string
}

export interface IRunMode {
  route: string
}

declare const SYSTEM_META_CONFIG: IMetaConfig
const metaConfig: any = SYSTEM_META_CONFIG
const nodeEnv = process.env.NODE_ENV

declare const GLOBAL_SERVER_CONFIG: IServerConfig
const serverConfig: any = GLOBAL_SERVER_CONFIG

declare const SYSTEM_RUN_MODE: IRunMode
const runMode = SYSTEM_RUN_MODE

export {
  metaConfig as SYSTEM_META_CONFIG,
  serverConfig as GLOBAL_SERVER_CONFIG,
  nodeEnv as NODE_ENV,
  runMode as SYSTEM_RUN_MODE,
}
